import { ActionTypes } from "./actions.js";
import { getInitialState } from "./state.js";
const initialState = getInitialState();
const reducer = (state = initialState, action) => {
    switch (action.type) {
        case ActionTypes.fetch:
            return {
                ...state,
                fetchStatus: "loading",
                error: undefined,
                fetchedAt: undefined
            };
        case ActionTypes.fetchSuccess:
        case ActionTypes.fetchSuccessAutoLoad:
            const flightsArr = action.type === ActionTypes.fetchSuccessAutoLoad
                ? [...state.flights, ...action.payload.flightOffers]
                : action.payload.flightOffers;
            const bestDealPrice = action.payload.flightDeals?.find((d) => d.key === "BEST")?.price;
            return {
                ...state,
                flights: flightsArr,
                atolProtectedStatus: action.payload.atolProtectedStatus,
                cabinClassExtension: action.payload.cabinClassExtension,
                subsidizedFaresSummary: action.payload.subsidizedFaresSummary || [],
                availableFilters: action.payload.aggregation,
                baggagePolicies: action.payload.baggagePolicies,
                flightDeals: action.payload.flightDeals,
                fetchStatus: "success",
                error: undefined,
                campaignBanner: action.payload.campaignBanner,
                banners: action.payload.banners,
                searchCriteria: action.payload.searchCriteria,
                searchId: action.payload.searchId,
                displayOptions: action.payload.displayOptions,
                sortingOptions: action.payload.sortingOptions,
                remoteBanners: action.payload.remoteBanners,
                personalisationSegments: action.payload.personalisationSegments,
                fetchedAt: new Date().getTime(),
                personalisationAttributes: action.payload.personalisationAttributes,
                priceAlertStatus: action.payload.priceAlertStatus,
                cachedBestFare: bestDealPrice ?? state.cachedBestFare,
                source: action.payload.source
            };
        case ActionTypes.fetchError:
            return {
                ...state,
                fetchStatus: "failed",
                error: action.payload,
                flights: [],
                availableFilters: {}
            };
        case ActionTypes.reset:
            return getInitialState();
        case ActionTypes.hidePrice:
            return {
                ...state,
                hidePrice: true
            };
        case ActionTypes.showPrice:
            return {
                ...state,
                hidePrice: false
            };
        case ActionTypes.addVisibleIndexes:
            return {
                ...state,
                visibleIndexes: action.payload
            };
        case ActionTypes.clearVisibleIndexes:
            return {
                ...state,
                visibleIndexes: undefined
            };
        default:
            return state;
    }
};
export { reducer, getInitialState };
